import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { GlobalFloorplanService } from "@domain/project/floorplan/global-floorplan.service";
import { TranslateFloorplanTagPipe } from "@domain/project/translate-floorplan-tag.pipe";
import { UserService } from "@domain/user/user.service";
import { BusinessScope } from "@lib/constants/business-scope";
import { AutocompleteSearchFilterPipe } from "@odx/angular/components/autocomplete";
import { Observable, switchMap } from "rxjs";

@Component({
  selector: "app-new-project-file-card",
  templateUrl: "./new-project-file-card.component.html",
  styleUrls: ["./new-project-file-card.component.scss"],
  imports: [UiKitModule, ReactiveFormsModule, AutocompleteSearchFilterPipe, TranslateFloorplanTagPipe],
  standalone: true,
})
export class NewProjectFileCardComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private floorplanTagService = inject(GlobalFloorplanService);
  private userService = inject(UserService);

  @Input() title!: string;
  @Input() fileUrl?: string;
  @Input() fileName?: string;
  @Input() isFloorplan?: boolean;

  @Output() delete$ = new EventEmitter();
  @Output() submit$ = new EventEmitter<FormGroup>();

  @ViewChild("submitButton")
  submitButton?: ElementRef;

  newFileForm!: FormGroup;

  protected tagList$?: Observable<string[]>;
  protected businessScope$ = this.userService.businessScope$;

  ngOnInit() {
    this.newFileForm = this.formBuilder.group({
      name: [this.fileName, Validators.required],
      description: [""],
      tags: new FormControl<string[] | null>(null),
    });

    if (this.isFloorplan) {
      this.tagList$ = this.businessScope$.pipe(
        switchMap((scope) => {
          return this.floorplanTagService.getFloorplanTags(scope);
        }),
      );
    }
  }

  triggerSubmit() {
    this.submitButton?.nativeElement.click();
    this.submit$.emit(this.newFileForm);
  }

  onDelete() {
    this.delete$.emit();
  }

  protected readonly BusinessScope = BusinessScope;
}
